export const FIELD_TYPE_TEXT = 'text' as const;
export const FIELD_TYPE_DATE = 'date' as const;
export const FIELD_TYPE_NUMBER = 'number' as const;
export const FIELD_TYPE_TEXTAREA = 'textarea' as const;
export const FIELD_TYPE_RADIO = 'radio' as const;
export const FIELD_TYPE_SELECT = 'select' as const;

export type FieldType =
  | typeof FIELD_TYPE_TEXT
  | typeof FIELD_TYPE_DATE
  | typeof FIELD_TYPE_NUMBER
  | typeof FIELD_TYPE_TEXTAREA
  | typeof FIELD_TYPE_RADIO
  | typeof FIELD_TYPE_SELECT;
